(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CommonComponent", [], factory);
	else if(typeof exports === 'object')
		exports["CommonComponent"] = factory();
	else
		root["CommonComponent"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition